import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import LeaderboardSkeletonLoader from './LeaderboardSkeletonLoader';

function LeaderboardPage() {
  const { eventId } = useParams(); 
  const [leaderboard, setLeaderboard] = useState([]);
  const [eventName, setEventName] = useState('');
  const [loading, setLoading] = useState(true);

  const [modalOpen, setModalOpen] = useState(false);
  const [scorecards, setScorecards] = useState([]);
  const [modalUser, setModalUser] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);

  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  useEffect(() => {
    const startTime = Date.now(); 
    setLoading(true);

    const fetchLeaderboard = async () => {
      try {
        const response = await fetch('/server/crazy-cup-server/getEventLeaderBoard.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ eventId }),
        });
        const data = await response.json();
        if (data.success) {
          setLeaderboard(data.data);
        } else {
          console.error('Error fetching leaderboard:', data.message);
        }
      } catch (error) {
        console.error('Error fetching leaderboard:', error);
      }
    };

    // Fetch event details to get the event name
    const fetchEventDetails = async () => {
      try {
        const response = await fetch(`/server/crazy-cup-server/getEventDetails.php?id=${eventId}`);
        const data = await response.json();
        if (data) {
          setEventName(data.cup_name);
        } else {
          console.error('Error fetching event details.');
        }
      } catch (error) {
        console.error('Error fetching event details:', error);
      }
    };

    Promise.all([fetchLeaderboard(), fetchEventDetails()]).finally(() => {
      const elapsedTime = Date.now() - startTime;
      const remainingTime = Math.max(700 - elapsedTime, 0);
      setTimeout(() => {
        setLoading(false);
      }, remainingTime);
    });
  }, [eventId]);

  // log scorecards for the clicked user
  useEffect(() => {
    console.log('Scorecards:', scorecards);
  }, [scorecards]);

  const handleRowClick = async (user) => {
    setModalUser(user);
    setModalLoading(true);
    setModalOpen(true);
    try {
      const response = await fetch('/server/crazy-cup-server/getUserEventScorecards.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ eventId, userId: user.user_id }),
      });
      const data = await response.json();
      if (data.success) {
        setScorecards(data.scorecards);
      } else {
        setScorecards([]);
      }
    } catch (error) {
      setScorecards([]);
    }
    setModalLoading(false);
  };
 
  return (
    <div id="leaderboard-page" className="page">
      <h1 className='page-title'>RESULTS</h1>
      {loading ? (
        <LeaderboardSkeletonLoader /> 
      ) : (
        <>
        <h2 id='leaderboard-title'>{eventName.toUpperCase()}</h2>
          <table className="leaderboard-table">
            <thead>
              <tr>
                <th>Rank</th>
                <th>Username</th>
                <th>Total Shots</th>
              </tr>
            </thead>
            <tbody>
              {leaderboard.map((user, index) => (
                <tr key={index} style={{cursor: 'pointer'}} onClick={() => handleRowClick(user)}>
                  <td>
                    {index === 0 ? (
                      <span className="rank-badge gold">1st</span>
                    ) : index === 1 ? (
                      <span className="rank-badge silver">2nd</span>
                    ) : index === 2 ? (
                      <span className="rank-badge bronze">3rd</span>
                    ) : (
                      index + 1
                    )}
                  </td>
                  <td>{user.username.toUpperCase()}</td>
                  <td>{user.total_shots}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <button className="back-button" onClick={() => window.history.back()}>
            Back
          </button>

          {/* --- Modal for user scorecards --- */}
          {modalOpen && (
            <div className="modal-overlay" onClick={() => setModalOpen(false)}>
              <div className="modal-content lb-scorecard-modal" onClick={e => e.stopPropagation()} style={{maxWidth: 800, width: '90%', overflow: 'scroll'}}>
                {/* event name */}
                <h2 className="modal-title">{eventName.toUpperCase()}</h2>
                {/* user name */}
                <h2>
                  {modalUser.username.toUpperCase()}
                </h2>
                {modalLoading ? (
                  <div>Loading...</div>
                ) : scorecards.length === 0 ? (
                  <div>No scorecards found for this user.</div>
                ) : (
                  scorecards.map((round, i) => {
                    const holeGroups = [];
                    for (let j = 0; j < round.holes.length; j += 9) {
                      holeGroups.push(round.holes.slice(j, j + 9));
                    }
                    return (
                      <div key={i} style={{ marginBottom: 24 }}>
                        <h3 style={{ margin: '12px 0' }}>{round.courseName}</h3>
                        {holeGroups.map((group, gIdx) => (
                          <table className="lb-scorecard-table" style={{ marginBottom: 16, width: '100%' }} key={gIdx}>
                            <thead>
                              <tr>
                                <th>Holes</th>
                                {group.map((hole) => (
                                  <th key={hole.hole_number}>{hole.hole_number}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <th>Score</th>
                                {group.map((hole) => {
                                  const shots = hole.score?.shots;
                                  const par = hole.par;
                                  let className = "score-circle score-par"; // default: par/neutral

                                  if (shots === 1) {
                                    className = "score-circle score-ace";
                                  } else if (shots === par - 1) {
                                    className = "score-circle score-birdie";
                                  } else if (shots === par + 1) {
                                    className = "score-circle score-bogey";
                                  } else if (shots > par + 1) {
                                    className = "score-circle score-double";
                                  }

                                  return (
                                    <td key={hole.hole_number}>
                                      {shots != null ? <span className={className}>{shots}</span> : ""}
                                    </td>
                                  );
                                })}
                              </tr>
                            </tbody>
                          </table>
                        ))}
                      </div>
                    );
                  })
                )}
                {/* Score color key */}
                  <div style={{ margin: '36px 0 0px 0', display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'center', justifyContent: 'center', fontSize: '0.8em' }}>
                    <span><span className="score-circle score-ace" style={{marginRight: 6}}>1</span> Hole-in-One</span>
                    <span><span className="score-circle score-birdie" style={{marginRight: 6}}>B</span> Birdie</span>
                    <span><span className="score-circle score-par" style={{marginRight: 6}}>P</span> Par</span>
                    <span><span className="score-circle score-bogey" style={{marginRight: 6}}>B</span> Bogey</span>
                    <span><span className="score-circle score-double" style={{marginRight: 6}}>D</span> Double Bogey+</span>
                  </div>

                <button className="button" onClick={() => setModalOpen(false)}>Close</button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default LeaderboardPage;